import React from 'react';
import { Box, Flex, Text, Tooltip, SimpleGrid } from '@chakra-ui/react';
import { MONTHS } from './constants';

/**
 * Grid ENE-DIC. Igual que OrdinalsPicker pero con meses.
 * `monthIdByNumber` mapea 1..12 al id real de la entidad month en BD
 * (viene del hook de meses del useMonthStudent legacy — el modal recibe
 * el mapa como prop desde LinkPaymentsModal para no repetir el fetch).
 */
export default function MonthsPicker({
  selected, // number[] — ids reales de month en BD
  reservedByPeers, // Map<monthId, peerPaymentId>
  blockedInDb, // Map<monthId, dbPaymentId>
  monthIdByNumber, // Map<1..12, monthId>
  onToggle,
  disabled,
}) {
  if (!monthIdByNumber || monthIdByNumber.size === 0) {
    return (
      <Text fontSize="xs" color="orange.700">
        No se pudieron cargar los meses. Recarga la página.
      </Text>
    );
  }

  const selectedSet = new Set(selected);

  return (
    <Box>
      <Text fontSize="11px" color="gray.500" fontWeight="600" mb={2} letterSpacing="0.05em">
        MESES QUE CUBRE ESTE PAGO
      </Text>
      <SimpleGrid columns={{ base: 4, md: 6 }} spacing={2}>
        {MONTHS.map((m) => {
          const monthId = monthIdByNumber.get(m.number);
          if (!monthId) {
            return (
              <Flex
                key={m.number}
                align="center"
                justify="center"
                px={2}
                py={2}
                borderWidth="1px"
                borderColor="#E2E8F0"
                bg="#F7FAFC"
                color="#A0AEC0"
                borderRadius="6px"
                fontSize="12px"
                fontWeight="600"
                cursor="not-allowed"
                opacity={0.5}
              >
                {m.short}
              </Flex>
            );
          }
          const isSelected = selectedSet.has(monthId);
          const peerId = reservedByPeers?.get(monthId);
          const dbId = blockedInDb?.get(monthId);
          const isBlocked = !isSelected && (peerId != null || dbId != null);
          const tooltip = peerId
            ? `Reservado por el Pago #${peerId} en este modal`
            : dbId
              ? `Ya chuleado por el Pago #${dbId}`
              : '';
          const btnBg = isSelected ? '#574feb' : isBlocked ? '#F7FAFC' : '#FFFFFF';
          const btnColor = isSelected ? '#FFFFFF' : isBlocked ? '#A0AEC0' : '#2D3748';
          const btnBorder = isSelected ? '#574feb' : isBlocked ? '#E2E8F0' : '#CBD5E0';

          const btn = (
            <Flex
              as="button"
              type="button"
              disabled={disabled || isBlocked}
              onClick={() => !isBlocked && !disabled && onToggle(monthId)}
              align="center"
              justify="center"
              px={2}
              py={2}
              borderWidth="1px"
              borderColor={btnBorder}
              bg={btnBg}
              color={btnColor}
              borderRadius="6px"
              fontSize="12px"
              fontWeight="600"
              cursor={isBlocked || disabled ? 'not-allowed' : 'pointer'}
              opacity={isBlocked ? 0.6 : 1}
              _hover={!isBlocked && !disabled ? { borderColor: '#574feb' } : {}}
            >
              {m.short}
            </Flex>
          );

          return tooltip ? (
            <Tooltip key={m.number} label={tooltip} placement="top" hasArrow>
              {btn}
            </Tooltip>
          ) : (
            <Box key={m.number}>{btn}</Box>
          );
        })}
      </SimpleGrid>
      <Text fontSize="11px" color="gray.500" mt={2}>
        {selected.length} de 12 seleccionados
      </Text>
    </Box>
  );
}
